import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface AssetsCellProps {
  rowData: ManagedFleet;
}

export default function AssetsCell({ rowData: { totals } }: AssetsCellProps) {
  return <TextCell text={String(totals?.enabledAssetsCount)} />;
}
